export default function ($http, Upload) {
    return function (model) {
        return Upload.upload({
            url: 'api/vehicle/notes/add',
            data: model
        });
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/notes/addNote.js